import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { addSection } from 'app/redux/store/features/sections'
import { defaultSection } from './defaultSection'
import AddSectionForm from './AddSectionForm'

const AddSection = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const { state } = useLocation()
    const { id } = state
    const [sectionData] = useState({ ...defaultSection, classId: id })
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { loading, error } = useSelector((state) => state.sections)

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)
        if (error) handleError(error)
        else {
            enqueueSnackbar('Section added successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/courses/setup/classes', { state: { navigateFrom: 'add-section' } })
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onAddSection = (formData) => {
        setApiCallInProgress(true)
        dispatch(addSection(formData ?? sectionData))
    }

    return (
        <React.Fragment>
            <AddSectionForm sectionData={sectionData} addSection={onAddSection} />
        </React.Fragment>
    )
}

export default AddSection
